var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items.length > 0)?_c('download-excel',{staticClass:"btn btn-default",attrs:{"data":_vm.getData(),"fields":_vm.getFields(),"worksheet":"Export","type":"csv","name":"export.xls","escapeCsv":false}},[_c('v-btn',[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-download")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }